import { render, staticRenderFns } from "./DownloadDocumentLink.vue?vue&type=template&id=502e9068&scoped=true"
import script from "./DownloadDocumentLink.vue?vue&type=script&lang=js"
export * from "./DownloadDocumentLink.vue?vue&type=script&lang=js"
import style0 from "./DownloadDocumentLink.vue?vue&type=style&index=0&id=502e9068&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e9068",
  null
  
)

export default component.exports